import { Fill, Stroke, Style, Circle } from "ol/style";
import Point from "ol/geom/Point.js";
import Polygon from "ol/geom/Polygon.js";
import LineString from "ol/geom/LineString.js";

const getFeatureStyle = (feature) => {
  const BLUE = "#0099ff";
  const WIDTH = 3;
  const featureGeometry = feature?.values_?.geometry;

  if (!featureGeometry) {
    return null;
  }

  if (featureGeometry instanceof Point) {
    return new Style({
      image: new Circle({
        radius: WIDTH * 2,
        fill: new Fill({
          color: BLUE,
        }),
      }),
    });
  } else if (featureGeometry instanceof Polygon) {
    return new Style({
      fill: new Fill({
        color: [255, 255, 255, 0.5],
      }),
      stroke: new Stroke({
        color: BLUE,
        width: WIDTH / 2,
      }),
    });
  } else if (featureGeometry instanceof LineString) {
    return new Style({
      stroke: new Stroke({
        color: BLUE,
        width: WIDTH,
      }),
    });
  } else {
    return null;
  }
};

export default getFeatureStyle;
